import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";
import type { DataViewWriteBody } from "../../../zodios/apiDefinitions/api/dataViews";

export const useCreateDataView = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: DataViewWriteBody) => await apiClient.createDataView(body),
    onSuccess: () => {
      successToast({ message: "Data view saved" });
      void queryClient.invalidateQueries({ queryKey: [{ entity: "DataViews" }] });
    },
    onError: (error) => {
      errorToast({ message: "Failed to save data view", error });
    },
  });
};
